import { start } from "repl";
import { config } from "../config/config";
import { getAuthToken } from "./tokenService.service";
import { get } from "jquery";

export const serviceLevelPerformanceService = {
  getpickupServiceLevelPerformance: async (
    start_date: string,
    end_date: string,
    branch_id: string
  ) => {
    const token = getAuthToken();

    const response = await fetch(
      `${config.baseURL}/servicelevelperformance/pickup`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ start_date, end_date, branch_id }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch pickup service level performance data");
    }

    const json = await response.json();
    return json.data;
  },
  getpickupServiceLevelPerformanceMonthly: async (
    branch_id: string,
    end_date: string
  ) => {
    const token = getAuthToken();

    const response = await fetch(
      `${config.baseURL}/servicelevelperformance/pickupmonthly`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ branch_id, end_date }),
      }
    );

    if (!response.ok) {
      throw new Error(
        "Failed to fetch pickup service level performance data monthly"
      );
    }

    const json = await response.json();
    return json.data;
  },

  getdeliveryServiceLevelPerformance: async (
    start_date: string,
    end_date: string,
    branch_id: string
  ) => {
    const token = getAuthToken();

    const response = await fetch(
      `${config.baseURL}/servicelevelperformance/delivery`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ start_date, end_date, branch_id }),
      }
    );

    if (!response.ok) {
      throw new Error(
        "Failed to fetch delivery service level performance data"
      );
    }

    const json = await response.json();
    return json.data;
  },
  getdeliveryServiceLevelPerformanceMonthly: async (
    branch_id: string,
    end_date: string
  ) => {
    const token = getAuthToken();

    const response = await fetch(
      `${config.baseURL}/servicelevelperformance/deliverymonthly`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ branch_id, end_date }),
      }
    );

    if (!response.ok) {
      throw new Error(
        "Failed to fetch delivery service level performance data monthly"
      );
    }

    const json = await response.json();
    return json.data;
  },
};
